import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';
import { getPhoneSearchFormats } from '../utils/phoneFormat';

export const useOrders = (phone, startDate = null, endDate = null) => {
  const [orders, setOrders] = useState([]);
  const [pintoOrders, setPintoOrders] = useState([]);
  const [normalOrders, setNormalOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      if (!phone) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        const searchFormats = getPhoneSearchFormats(phone);
        
        let query = supabase
          .from('orders')
          .select('*')
          .in('phone', searchFormats)
          .order('delivery_date', { ascending: false });

        if (startDate) {
          query = query.gte('delivery_date', new Date(startDate).toISOString());
        }
        
        if (endDate) {
          // Set to end of day
          const end = new Date(endDate);
          end.setHours(23, 59, 59, 999);
          query = query.lte('delivery_date', end.toISOString());
        }

        const { data, error: err } = await query;

        if (err) throw err;

        // Classify orders
        const isPinto = (o) => {
          if (o.meals_deducted > 0) return true;
          const menuName = o.menu_name || '';
          const lower = menuName.toLowerCase();
          return lower.includes('ปิ่นโต') || lower.includes('pinto') || lower.includes('package') || lower.includes('เซ็ต') || lower.includes('โปรโมชั่น') || lower.includes('คอร์ส');
        };

        const all = data || [];
        const pinto = all.filter(o => isPinto(o));
        const normal = all.filter(o => !isPinto(o));

        setOrders(all);
        setPintoOrders(pinto);
        setNormalOrders(normal);
      } catch (err) {
        console.error('Fetch orders error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [phone, startDate, endDate]);

  return { 
    orders, 
    pintoOrders, 
    normalOrders, 
    totalCount: orders.length,
    loading, 
    error 
  };
};
